// TODO also need to update src/components/common/AttackTypeIcon.js for FA icons (or more appropriately, make it use this instead)
import { keyframes } from '@emotion/react'
import {
  faArrowDown,
  faArrowsUpDownLeftRight,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faBolt,
  faBookOpen,
  faBuilding,
  faCalendar,
  faChartLineUp,
  faChartNetwork,
  faChartPieSimple,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleQuestion,
  faCircleTrash,
  faClipboardList,
  faClockRotateLeft,
  faClose,
  faCode,
  faCopy,
  faCube,
  faEdit,
  faEye,
  faEyeSlash,
  faFlask,
  faFlaskVial,
  faGear,
  faGraduationCap,
  faGrid2,
  faJoystick,
  faKey,
  faLayerGroup,
  faLock,
  faMagnifyingGlass,
  faMessageQuestion,
  faMinus,
  faPencil,
  faPlus,
  faPowerOff,
  faQuestion,
  faTrash,
  faWarning,
  faWrench,
  faGears
} from '@fortawesome/pro-light-svg-icons'
import {
  faArrowDown as faSolidArrowDown,
  faArrowTrendDown as faSolidArrowTrendDown,
  faArrowTrendUp as faSolidArrowTrendUp,
  faArrowUp as faSolidArrowUp,
  faArrowUpRightFromSquare as faSolidArrowUpRightFromSquare,
  faArrowsRotate as faSolidArrowsRotate,
  faBuilding as faSolidBuilding,
  faCalendar as faSolidCalendar,
  faCaretCircleRight as faSolidCaretCircleRight,
  faCaretDown as faSolidCaretDown,
  faCaretLeft as faSolidCaretLeft,
  faCaretRight as faSolidCaretRight,
  faCaretUp as faSolidCaretUp,
  faCheck as faSolidCheck,
  faCircle as faSolidCircle,
  faCircleCheck as faSolidCircleCheck,
  faCircleInfo as faSolidCircleInfo,
  faCircleMinus as faSolidCircleMinus,
  faCircleXmark as faSolidCircleXmark,
  faClose as faSolidClose,
  faCreditCard as faSolidCreditCard,
  faDash as faSolidDash,
  faEllipsis as faSolidEllipsis,
  faEllipsisVertical as faSolidEllipsisVertical,
  faGalaxy as faSolidGalaxy,
  faMinus as faSolidMinus,
  faPlay as faSolidPlay,
  faTrophy as faSolidTrophy,
  faUser as faSolidUser,
  faUserGroup as faSolidUserGroup,
  faWarning as faSolidWarning
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'

import { ReactComponent as old_navExperiment } from 'assets/experiments-nav.svg'
import { ReactComponent as gremlinLogoPrimary } from 'assets/gremlin-logo-primary.svg'
import { ReactComponent as gremlinLogoWhite } from 'assets/gremlin-logo-white.svg'
import { ReactComponent as mascotReversedIcon } from 'assets/gremlin-mascot-reversed.svg'
import { ReactComponent as gremlinHeadLogo } from 'assets/gremlin-mascot.svg'
import { ReactComponent as old_blackhole } from 'assets/icons/args/blackhole-icon.svg'
import { ReactComponent as blockCount } from 'assets/icons/args/block-count-icon.svg'
import { ReactComponent as BlockSize } from 'assets/icons/args/block-size-icon.svg'
import { ReactComponent as cores } from 'assets/icons/args/cores-icon.svg'
import { ReactComponent as corrupt } from 'assets/icons/args/corrupt-icon.svg'
import { ReactComponent as cpu } from 'assets/icons/args/cpu-icon.svg'
import { ReactComponent as delay } from 'assets/icons/args/delay-icon.svg'
import { ReactComponent as device } from 'assets/icons/args/device-icon.svg'
import { ReactComponent as dir } from 'assets/icons/args/dir-icon.svg'
import { ReactComponent as disk } from 'assets/icons/args/disk-icon.svg'
import { ReactComponent as dns } from 'assets/icons/args/dns-icon.svg'
import { ReactComponent as fullMatch } from 'assets/icons/args/full-match-icon.svg'
import { ReactComponent as gigabytes } from 'assets/icons/args/gigabytes-icon.svg'
import { ReactComponent as host } from 'assets/icons/args/host-icon.svg'
import { ReactComponent as io } from 'assets/icons/args/io-icon.svg'
import { ReactComponent as ipaddress } from 'assets/icons/args/ipaddress-icon.svg'
import { ReactComponent as killChildren } from 'assets/icons/args/kill-children-icon.svg'
import { ReactComponent as latency } from 'assets/icons/args/latency-icon.svg'
import { ReactComponent as length } from 'assets/icons/args/length-icon.svg'
import { ReactComponent as MB } from 'assets/icons/args/megabytes-icon.svg'
import { ReactComponent as memory } from 'assets/icons/args/memory-icon.svg'
import { ReactComponent as mode } from 'assets/icons/args/mode-icon.svg'
import { ReactComponent as monitor } from 'assets/icons/args/monitor-icon.svg'
import { ReactComponent as newest } from 'assets/icons/args/newest-icon.svg'
import { ReactComponent as ntp } from 'assets/icons/args/ntp-icon.svg'
import { ReactComponent as offset } from 'assets/icons/args/offset-icon.svg'
import { ReactComponent as oldest } from 'assets/icons/args/oldest-icon.svg'
import { ReactComponent as packetLoss } from 'assets/icons/args/packet_loss-icon.svg'
import { ReactComponent as percent } from 'assets/icons/args/percent-icon.svg'
import { ReactComponent as port } from 'assets/icons/args/port-icon.svg'
import { ReactComponent as processKiller } from 'assets/icons/args/process-icon.svg'
import { ReactComponent as protocol } from 'assets/icons/args/protocol-icon.svg'
import { ReactComponent as reboot } from 'assets/icons/args/reboot-icon.svg'
import { ReactComponent as shutdown } from 'assets/icons/args/shutdown-icon.svg'
import { ReactComponent as timeTravel } from 'assets/icons/args/time_travel-icon.svg'
import { ReactComponent as workers } from 'assets/icons/args/workers-icon.svg'
import { ReactComponent as old_checklist } from 'assets/icons/checklist.svg'
import { ReactComponent as closeOctagonOutlineIcon } from 'assets/icons/close-octagon-outline.svg'
import { ReactComponent as old_cube } from 'assets/icons/cube.svg'
import { ReactComponent as old_services } from 'assets/icons/services.svg'
import { ReactComponent as old_stack } from 'assets/icons/stack.svg'
import { ReactComponent as old_trafficLight } from 'assets/icons/traffic-light.svg'
import { ReactComponent as old_add } from 'assets/iconsNew/add.svg'
import { ReactComponent as old_api } from 'assets/iconsNew/api.svg'
import { ReactComponent as old_arrowDownOutline } from 'assets/iconsNew/arrow-down-outline.svg'
import { ReactComponent as old_arrowUpOutline } from 'assets/iconsNew/arrow-up-outline.svg'
import { ReactComponent as old_attacksIcon } from 'assets/iconsNew/attacks.svg'
import { ReactComponent as old_caretBack } from 'assets/iconsNew/caret-back.svg'
import { ReactComponent as old_caretDown } from 'assets/iconsNew/caret-down.svg'
import { ReactComponent as old_caretForwardCircle } from 'assets/iconsNew/caret-forward-circle.svg'
import { ReactComponent as old_caretForward } from 'assets/iconsNew/caret-forward.svg'
import { ReactComponent as caretNeutral } from 'assets/iconsNew/caret-neutral.svg' // TODO need to find replacement for this
import { ReactComponent as old_caretUp } from 'assets/iconsNew/caret-up.svg'
import { ReactComponent as old_checkmarkDouble } from 'assets/iconsNew/checkmark-double.svg'
import { ReactComponent as old_checkmark } from 'assets/iconsNew/checkmark.svg'
import { ReactComponent as old_chevronBack } from 'assets/iconsNew/chevron-back.svg'
import { ReactComponent as old_chevronDown } from 'assets/iconsNew/chevron-down.svg'
import { ReactComponent as old_chevronForward } from 'assets/iconsNew/chevron-forward.svg'
import { ReactComponent as old_chevronUp } from 'assets/iconsNew/chevron-up.svg'
import { ReactComponent as clients } from 'assets/iconsNew/clients.svg' // TODO find replacement
import { ReactComponent as old_close } from 'assets/iconsNew/close.svg'
import { ReactComponent as old_cog } from 'assets/iconsNew/cog.svg'
import { ReactComponent as old_company } from 'assets/iconsNew/company.svg'
import { ReactComponent as old_copy } from 'assets/iconsNew/copy.svg'
import { ReactComponent as old_docs } from 'assets/iconsNew/docs.svg'
import { ReactComponent as old_edit } from 'assets/iconsNew/edit.svg'
import { ReactComponent as old_ellipsisHorizontal } from 'assets/iconsNew/ellipsis-horizontal.svg'
import { ReactComponent as old_ellipsisVertical } from 'assets/iconsNew/ellipsis-vertical.svg'
import { ReactComponent as old_eyeOff } from 'assets/iconsNew/eye-off.svg'
import { ReactComponent as old_eye } from 'assets/iconsNew/eye.svg'
import { ReactComponent as old_grid } from 'assets/iconsNew/grid.svg'
import { ReactComponent as helm } from 'assets/iconsNew/helm.svg' // TODO no clear replacement - maybe dharmachakra? but that has more spokes - this is k8s specific
import { ReactComponent as old_info } from 'assets/iconsNew/info.svg'
import { ReactComponent as old_key } from 'assets/iconsNew/key.svg'
import { ReactComponent as old_lock } from 'assets/iconsNew/lock.svg'
import { ReactComponent as old_move } from 'assets/iconsNew/move.svg'
import { ReactComponent as old_power } from 'assets/iconsNew/power.svg'
import { ReactComponent as old_remove } from 'assets/iconsNew/remove.svg'
import { ReactComponent as old_report } from 'assets/iconsNew/report.svg'
import { ReactComponent as old_scenarios } from 'assets/iconsNew/scenarios.svg'
import { ReactComponent as old_schedulesIcon } from 'assets/iconsNew/schedule.svg'
import { ReactComponent as search } from 'assets/iconsNew/search.svg'
import { ReactComponent as share } from 'assets/iconsNew/share.svg'
import { ReactComponent as starOutline } from 'assets/iconsNew/star-outline.svg'
import { ReactComponent as star } from 'assets/iconsNew/star.svg'
import { ReactComponent as support } from 'assets/iconsNew/support.svg'
import { ReactComponent as trendingDown } from 'assets/iconsNew/trending-down.svg'
import { ReactComponent as trendingUp } from 'assets/iconsNew/trending-up.svg'
import { ReactComponent as unlock } from 'assets/iconsNew/unlock.svg'
import { ReactComponent as user } from 'assets/iconsNew/user.svg'
import { ReactComponent as users } from 'assets/iconsNew/users.svg'
import { ReactComponent as warning } from 'assets/iconsNew/warning.svg'
import { ReactComponent as targetIcon } from 'assets/targets.svg'

// for comparison storybook
const oldIcons = {
  old_navExperiment,
  old_blackhole,
  old_checklist,
  old_cube,
  old_services,
  old_stack,
  old_trafficLight,
  old_add,
  old_api,
  old_arrowDownOutline,
  old_arrowUpOutline,
  old_attacksIcon,
  old_caretBack,
  old_caretDown,
  old_caretForwardCircle,
  old_caretForward,
  old_caretUp,
  old_checkmarkDouble,
  old_checkmark,
  old_chevronBack,
  old_chevronDown,
  old_chevronForward,
  old_chevronUp,
  old_close,
  old_cog,
  old_company,
  old_copy,
  old_docs,
  old_edit,
  old_ellipsisHorizontal,
  old_ellipsisVertical,
  old_eyeOff,
  old_eye,
  old_grid,
  old_info,
  old_key,
  old_lock,
  old_move,
  old_power,
  old_remove,
  old_report,
  old_scenarios,
  old_schedulesIcon
}

const attacks = {
  cpu,
  disk,
  dns,
  io,
  latency,
  memory,
  packetLoss,
  process_killer: processKiller,
  shutdown,
  time_travel: timeTravel
}

const args = {
  // api,
  'all-cores': cores,
  'block-count': blockCount,
  'block-size': BlockSize,
  cores,
  corrupt,
  delay,
  device,
  dir,
  // docs,
  egressPorts: port,
  egress_port: port,
  exact: dir,
  'full-match': fullMatch,
  full: fullMatch,
  gigabytes,
  group: users,
  host,
  hostname: port,
  ingressPorts: port,
  ingress_port: port,
  interval: delay,
  ipaddress,
  ipprotocol: protocol,
  'kill-children': killChildren,
  kill_children: killChildren,
  length,
  megabytes: MB,
  MB,
  mode,
  monitor,
  ms: delay,
  newest,
  ntp,
  offset,
  oldest,
  packet_loss: packetLoss,
  percent,
  process: processKiller,
  protocol,
  reboot,
  'source-ports': port,
  src_port: port,
  port,
  workers,
  user,
  volumePercentage: percent
}

const faAttacks = {
  blackhole: faSolidGalaxy
}

const faArgs = {
  api: faCode,
  'block-count': faLayerGroup,
  'block-size': faCube,
  docs: faBookOpen
}

const icons = {
  ...attacks,
  ...args,
  ...oldIcons,
  caretNeutral,
  clients,
  closeOctagonOutlineIcon,
  gremlinHeadLogo,
  gremlinLogoPrimary,
  gremlinLogoWhite,
  helm,
  trendingDown,
  trendingUp,
  mascotReversedIcon,
  search,
  share,
  star,
  starOutline,
  support,
  targetIcon,
  unlock,
  users,
  warning
}

type IconProps = {
  icon: string
  className?: string
  spinning?: boolean
}

// list any solid icons here and prefix their name with "solid"
// to make it obvious in the code that it's intended to be a solid icon and not the standard light version
const solidFontAwesomeIcons = {
  solidArrowDown: faSolidArrowDown,
  solidArrowTrendDown: faSolidArrowTrendDown,
  solidArrowTrendUp: faSolidArrowTrendUp,
  solidArrowUp: faSolidArrowUp,
  solidArrowsRotate: faSolidArrowsRotate,
  solidBuilding: faSolidBuilding,
  solidCalendar: faSolidCalendar,
  solidCaretCircleRight: faSolidCaretCircleRight,
  solidCaretDown: faSolidCaretDown,
  solidCaretLeft: faSolidCaretLeft,
  solidCaretRight: faSolidCaretRight,
  solidCaretUp: faSolidCaretUp,
  solidCheck: faSolidCheck,
  solidCircle: faSolidCircle,
  solidCircleCheck: faSolidCircleCheck,
  solidCircleInfo: faSolidCircleInfo,
  solidCircleMinus: faSolidCircleMinus,
  solidCircleXmark: faSolidCircleXmark,
  solidClose: faSolidClose,
  solidCreditCard: faSolidCreditCard,
  solidDash: faSolidDash,
  solidEllipsis: faSolidEllipsis,
  solidEllipsisVertical: faSolidEllipsisVertical,
  solidGalaxy: faSolidGalaxy,
  solidMinus: faSolidMinus,
  solidPlay: faSolidPlay,
  solidTrophy: faSolidTrophy,
  solidUser: faSolidUser,
  solidUserGroup: faSolidUserGroup,
  solidWarning: faSolidWarning
}

// Note: when you add new FontAwesome icons to replace old icons,
//       please make sure to update the icon comparison storybook
//       located in src/components/IconComparisons.stories.tsx
const fontAwesomeIcons = {
  ...faAttacks,
  ...faArgs,
  ...solidFontAwesomeIcons,
  arrowLeft: faArrowLeft,
  arrowRight: faArrowRight,
  arrowUpRightFromSquare: faSolidArrowUpRightFromSquare,
  joystick: faJoystick,
  magnifyingGlass: faMagnifyingGlass,
  circleQuestion: faCircleQuestion,
  close: faClose,
  chartLineUp: faChartLineUp,
  chartNetwork: faChartNetwork,
  flaskVial: faFlaskVial,
  flask: faFlask,
  layerGroup: faLayerGroup,
  chevronLeft: faChevronLeft,
  chevronDown: faChevronDown,
  chevronRight: faChevronRight,
  chevronUp: faChevronUp,
  plus: faPlus,
  code: faCode,
  arrowDown: faArrowDown,
  arrowUp: faArrowUp,
  bolt: faBolt,
  checkDouble: faCheckDouble,
  gear: faGear,
  gears: faGears,
  building: faBuilding,
  copy: faCopy,
  bookOpen: faBookOpen,
  pencil: faPencil,
  eye: faEye,
  eyeSlash: faEyeSlash,
  graduationCap: faGraduationCap,
  grid2: faGrid2,
  key: faKey,
  lock: faLock,
  arrowsUpDownLeftRight: faArrowsUpDownLeftRight,
  powerOff: faPowerOff,
  minus: faMinus,
  chartPieSimple: faChartPieSimple,
  clipboardList: faClipboardList,
  clockRotateLeft: faClockRotateLeft,
  calendar: faCalendar,
  circleCheck: faCircleCheck,
  circleTrash: faCircleTrash,
  edit: faEdit,
  trash: faTrash,
  question: faQuestion,
  warning: faWarning,
  cube: faCube,
  wrench: faWrench,
  messageQuestion: faMessageQuestion
}

export type FontAwesomeIconName = keyof typeof fontAwesomeIcons | 'clients'
export type LegacyIconName = keyof typeof icons
export type IconName = FontAwesomeIconName | LegacyIconName

const spin = keyframes`
  0% {
    transform: rotate(0turn)
  }
  100% {
    transform: rotate(1turn)
  }
`

const Icon = React.forwardRef<
  React.Ref<any>,
  IconProps & React.HTMLAttributes<HTMLElement>
>(({ icon, className, spinning = false, ...rest }, ref) => {
  if (!fontAwesomeIcons[icon]) {
    const IconComponent = icons[icon] || old_navExperiment

    return (
      <IconComponent
        ref={ref}
        className={clsx('Icon', className)}
        css={[
          {
            shapeRendering: 'geometricPrecision'
          },
          spinning ? { animation: `${spin} 2s linear infinite` } : null
        ]}
        {...rest}
      />
    )
  }

  return (
    // @ts-ignore the types for this 3rd party component are bonkers
    <FontAwesomeIcon
      // @ts-ignore third party screwiness
      ref={ref}
      className={clsx('Icon', className)}
      css={[
        {
          shapeRendering: 'geometricPrecision'
        },
        spinning ? { animation: `${spin} 2s linear infinite` } : null
      ]}
      icon={fontAwesomeIcons[icon] || faFlask}
      {...rest}
    />
  )
})

Icon.displayName = 'Icon'

export default Icon
